module.exports = __webpack_public_path__ + "img/Villa_Borna_12.a29eb36d.jpg";